class PagePasswordProtect extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.page-password-form');
    this.input = this.querySelector('input[type="password"]');
    this.errorMessage = this.querySelector('.password-error');
    this.promptContainer = this.querySelector('.page-password-prompt');
    this.template = this.querySelector('.protected-content-template');
    
    this.expectedPassword = this.dataset.password;
    this.pageId = this.dataset.pageId;
    this.sessionKey = `unlocked_page_${this.pageId}`;
    
    // Check if user already unlocked this page in the current session
    if (sessionStorage.getItem(this.sessionKey) === 'true') {
      this.unlockPage();
    } else {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.input.value === this.expectedPassword) {
      sessionStorage.setItem(this.sessionKey, 'true');
      this.unlockPage();
    } else {
      this.errorMessage.style.display = 'block';
    }
  }

  unlockPage() {
    // Hide the password prompt
    this.promptContainer.style.display = 'none';
    
    // Extract and append the protected content from the template
    if (this.template) {
      const clone = this.template.content.cloneNode(true);
      this.appendChild(clone);
      
      // Optionally remove the template element from the DOM to keep it clean
      this.template.remove();
    }
  }
}

customElements.define('page-password-protect', PagePasswordProtect);
